import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetUserByCpfUseCaseInterface } from 'domain/usecases';

export class RemoteGetUserByCpf implements GetUserByCpfUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetUserByCpfUseCaseInterface.Params,
  ): Promise<GetUserByCpfUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.cpf}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
